import React from 'react';
import PropTypes from 'prop-types';
import { withLastLocation } from 'react-router-last-location';
import { GeneralErrorModal } from './index';
import PrizeInfoModal from './PrizeInfoModal';


const RenderActiveModals = props => {
  const { closeModal, isModalOpen, modalData } = props;
  if (isModalOpen('raffleErrorModal')) {
    const { turnBackSantra, forceBackOnClose } = modalData.raffleErrorModal;
    return (
      <GeneralErrorModal
        turnBackSantra= { turnBackSantra }
        forceBackOnClose= { forceBackOnClose }
        modalClose={ () => {
          closeModal('raffleErrorModal');
        } }
      />
    );
  // eslint-disable-next-line react/prop-types
  } else if (isModalOpen('ScratchCardInfoModal')) {
    const { prizeData } = modalData.ScratchCardInfoModal;
    return (
      <PrizeInfoModal
        prizeData={ prizeData }
        modalClose={ () => {
          closeModal('ScratchCardInfoModal');
        } }
      />
    );
  }
  
  return null;
};

RenderActiveModals.propTypes = {
  closeModal: PropTypes.func,
  openModal: PropTypes.func,
  isModalOpen: PropTypes.func,
  modalData: PropTypes.object
};

export default withLastLocation(RenderActiveModals);
